import { useEffect, useState, type PropsWithChildren } from 'react'

const entrySeenKey = 'swell.entryAnimationSeen'

export function EntryAnimation({ children }: PropsWithChildren) {
  const [showAnimation, setShowAnimation] = useState(() => {
    try {
      return window.sessionStorage.getItem(entrySeenKey) !== 'true'
    } catch {
      return true
    }
  })

  useEffect(() => {
    if (!showAnimation) return

    const timer = window.setTimeout(() => {
      try {
        window.sessionStorage.setItem(entrySeenKey, 'true')
      } catch {
        // Storage can be unavailable in restrictive browser modes; animation still degrades safely.
      }
      setShowAnimation(false)
    }, 900)

    return () => window.clearTimeout(timer)
  }, [showAnimation])

  return (
    <>
      {children}
      {showAnimation ? (
        <div className="swell-entry-animation" aria-hidden="true">
          <div className="swell-entry-grid" />
          <div className="swell-entry-network">
            <span className="swell-entry-node node-a" />
            <span className="swell-entry-node node-b" />
            <span className="swell-entry-node node-c" />
            <span className="swell-entry-node node-d" />
            <span className="swell-entry-path path-a" />
            <span className="swell-entry-path path-b" />
            <span className="swell-entry-path path-c" />
            <span className="swell-entry-pulse" />
          </div>
          <div className="swell-entry-wordmark">Swell AI</div>
        </div>
      ) : null}
    </>
  )
}
